/*
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2023-11-20 14:58:58
 * @LastEditors: szj
 * @LastEditTime: 2024-03-02 16:27:33
 */
import { ref } from 'vue'
import { postFlyToPoint, PostFlyToPointBody, deleteFlyToPoint, postTakeoffToPoint, PostTakeoffToPointBody } from '/@/api/drone-control/drone'
import { message } from 'ant-design-vue'

export function useDroneControl () {
  const droneControlPanelVisible = ref(false)

  function setDroneControlPanelVisible (visible: boolean) {
    droneControlPanelVisible.value = visible
  }

  async function flyToPoint (sn: any,height:any, body: PostFlyToPointBody) {
    const res = await postFlyToPoint(sn,height, body)
    return res
  }

  async function stopFlyToPoint (sn: string) {
    const { code } = await deleteFlyToPoint(sn)
    if (code === 0) {
      // message.success('急停成功')
      // message.success('结束飞行成功')
    }
  }

  async function takeoffToPoint (sn: string, body: PostTakeoffToPointBody) {
    const { code } = await postTakeoffToPoint(sn, body)
    if (code === 0) {
      // message.success('一键起飞成功')
    }
  }

  return {
    droneControlPanelVisible,
    setDroneControlPanelVisible,
    flyToPoint,
    stopFlyToPoint,
    takeoffToPoint
  }
}
